<template>
  <div>
    <!-- 基本信息 -->
    <!-- 开票信息 -->
    <Basics :dataInfo="dataInfo"  />
    <el-row :gutter="10">
      <el-col :span="8">
        <!-- 逾期情况 -->

        <OverdueSituation :dataInfo="dataInfo" />
      </el-col>
      <el-col :span="8">
        <!-- 客户授信 -->

        <CustomerCredit />
      </el-col>
      <el-col :span="8">
        <!-- 关联企业 -->
        <RelationEnterprise />
        
        <!-- 客户评级 -->

        <!-- <CustomerGrade /> -->
      </el-col>
    </el-row>

    <!-- 客户资产 -->
    <CustomerAssets :dataInfo="dataInfo" />

    <!-- 2021年第三季度报告 -->
    <QuarterReport />

    <el-row :gutter="10">
      <!-- <el-col :span="8"> -->
        <!-- 关联企业 -->
        <!-- <RelationEnterprise />
      </el-col> -->
      <el-col :span="8">
        <!-- 客户跟进 -->

        <FollowUp />
      </el-col>
      <el-col :span="8">
        <!-- 历史项目 -->

        <HistoryItems />
      </el-col>
      
    </el-row>
  </div>
</template>

<script>
import Basics from "./components/basics.vue";
import OverdueSituation from "./components/overdueSituation.vue";
import CustomerCredit from "./components/customerCredit.vue";
import CustomerGrade from "./components/customerGrade.vue";
import CustomerAssets from "./components/customerAssets.vue";
import QuarterReport from "./components/quarterReport.vue";
import RelationEnterprise from "./components/relationEnterprise.vue";
import FollowUp from "./components/followUp.vue";
import HistoryItems from "./components/historyItems.vue";
export default {
  name: "overview",
  components: {
    Basics,
    OverdueSituation,
    CustomerCredit,
    CustomerGrade,
    CustomerAssets,
    QuarterReport,
    RelationEnterprise,
    FollowUp,
    HistoryItems,
  },

  data() {
    return {};
  },
  props: {
    dataInfo: {
      type: Object,
      default:()=>{
        return {}
      }
    },
  },
  methods: {
    // btnClick() {
    //   this.$emit("fatherEvent", "foodNews");
    // },
  },
};
</script>
<style scoped lang="scss">
</style>

